import React from "react";
import { Link } from "react-router-dom";
import BrilloLogo from "@/components/BrilloLogo";

export default function Navbar({ onCtaClick }) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50" style={{ background: "rgba(31,31,31,0.65)", backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)" }}>
      <div className="bf-container flex items-center justify-between py-5">
        <Link to="/" data-testid="nav-home-link" aria-label="Ir al inicio">
          <BrilloLogo className="h-7 w-auto" />
        </Link>
        <button
          onClick={onCtaClick}
          data-testid="nav-cta-button"
          className="bf-btn-coral px-7 py-3"
        >
          Conversemos
        </button>
      </div>
    </header>
  );
}
